import React, { useState } from "react";

const WhatsAppChat = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);
  const [message, setMessage] = useState("");

  const contacts = [
    { name: "Peatonal Drago 72", phone: "542916435709" },
    { name: "Chiclana 130", phone: "2914629352" },
  ];

  const toggleModal = () => {
    setIsOpen(!isOpen);
    setSelectedContact(null);
    setMessage("");
  };

  const handleContactClick = (contact) => {
    setSelectedContact(contact);
  };

  const handleSendMessage = () => {
    if (selectedContact && message) {
    //   const whatsappLink = `https://wa.me/${selectedContact.phone}?text=${encodeURIComponent(
      const whatsappLink = `https://web.whatsapp.com/send/?phone=${selectedContact.phone}?text=${encodeURIComponent(
        message
      )}`;
      window.open(whatsappLink, "_blank");
    }
  };

  return (
    <div>
      {/* Botón flotante de WhatsApp */}
      <button
        onClick={toggleModal}
        style={{
          position: "fixed",
          bottom: "20px",
          right: "22px",
          backgroundColor: "#25D366",
          color: "white",
          borderRadius: "50%",
          width: "60px",
          height: "60px",
          border: "none",
          cursor: "pointer",
          fontSize: "24px",
          zIndex: "102",
        }}
      >
        <i class="fa fa-whatsapp"></i>
      </button>

      {/* Modal flotante */}
      {isOpen && (
        <div
          style={{
            position: "fixed",
            bottom: "90px",
            right: "20px",
            backgroundColor: "#f59c00",
            boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
            borderRadius: "10px",
            padding: "15px",
            width: "320px",
          }}
        >
          <button
            onClick={toggleModal}
            style={{
              float: "right",
              background: "red",
              color: "white",
              border: "none",
              cursor: "pointer",
              borderRadius: "20%",
              top: "-4px",
              position: "relative",
            }}
          >
            ✖
          </button>
          <h5>Consultanos...</h5>
          {!selectedContact ? (
            contacts.map((contact, index) => (
              <button
                key={index}
                onClick={() => handleContactClick(contact)}
                style={{
                  display: "block",
                  width: "100%",
                  padding: "10px",
                  marginBottom: "5px",
                  background: "#000",
                  border: "none",
                  color: "white",
                  cursor: "pointer",
                  textAlign: "left",
                  borderRadius: "5px",
                }}
              >
                <img
                  src="/iso-Celuba.png"
                  alt={contact.name}
                  style={{ width: "30px", height: "30px"}} />
                {contact.name}
              </button>
            ))
          ) : (
            <div>
              <h5>Enviar mensaje a <strong>{selectedContact.name}</strong></h5>
              <textarea
                placeholder="Escribe tu mensaje..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                style={{
                  width: "100%",
                  height: "50px",
                  marginBottom: "10px",
                  background: "##f59c00",
                  border: "1px solid #33333399",
                  lineHeight: "1.25rem",
                  borderRadius: "4px",
                  outline: "none",
                }}
              />
              <button
                onClick={handleSendMessage}
                style={{
                  width: "100%",
                  padding: "10px",
                  background: "#25D366",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Enviar
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default WhatsAppChat;
